import { getAppName, getLangFromQuery } from "@/lib/utils";

export const HOST: string =
  import.meta.env.VITE_MESSENGER_HOST ||
  (import.meta.env.PROD && !import.meta.env.VITE_TEST
    ? ''
    : 'https://api.aitu.dev');
export const MEDIAHOST: string =
  import.meta.env.VITE_MEDIA_HOST ||
  (import.meta.env.PROD && !import.meta.env.VITE_TEST
    ? ''
    : 'https://media.aitu.dev');

export const API_CLIENT_OPTIONS = {
  withCredentials: true,
} as unknown as Record<string, string>; // Override of upstream type error.

export const logOut = (refresh?: boolean) => {
  localStorage.removeItem('token');
  localStorage.removeItem('userId');
  if (refresh) {
    window.location.reload();
  }
  // localStorage.removeItem('installationId');
};

export const APP_NAME = getAppName();
export const LANG = getLangFromQuery();
